import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "M15 6v6h4l-7 7-7-7h4V6h6z", stroke: `${color}` })
    }
  );
};
Icon.displayName = "ArrowBigDown";
const ArrowBigDown = memo(themed(Icon));
export {
  ArrowBigDown
};
//# sourceMappingURL=arrow-big-down.js.map
